import { Component,  Input, EventEmitter, Output } from '@angular/core';
import { performerStatus, colorsByStatus, performerStatusNames } from 'src/app/store/performers.era';
import { BriefStatus, QuoteStatus, StatusType } from 'globals/store/share.data';
import { briefStatus } from './../../store/performers.era';
import { GreyWrapperComponent } from './grey-wrapper.component';
import { MatMenu, MatMenuModule } from '@angular/material/menu';
import { IconComponent } from '../icon/icon.component';
import { TrafficLightDropdownComponent } from '../misc/traffic-light-dropdown.component';
import { CommonModule } from '@angular/common';
import { DeleteButtonComponent } from '../buttons/delete-button.component';
import { InverseButtonComponent } from '../buttons/inverse-button.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@Component({
    selector: 'status-wrapper',
    template: `
<grey-wrapper *ngIf="!wideFormat" [bottomHeight]="readOnly ? null : '40px'">
  <div class="status-body">
    <div style="display: flex; flex-wrap: wrap;">
      <ng-content></ng-content>
      <ng-container *ngIf="!!middleText">
        <div>{{ middleText }}</div>
      </ng-container>
    </div>
    <div style="flex:1"></div>
    <delete-button *ngIf="!readOnly && !threeDotOptions" deleteButtonText="REMOVE" [deleteText]="deleteText" [deleteTitle]="deleteTitle" (delete)="delete.emit($event)"></delete-button>
    <img class="logo" *ngIf="logoUrl" class="logo" [src]="logoUrl">
    <ng-container [ngTemplateOutlet]="dotMenu"></ng-container>
  </div>
  <ng-container *ngIf="!readOnly" class="bottom"> <!-- interestingly, this bottom "class" helps as an ng-content selector.  Don't delete !-->
    <traffic-light-dropdown
      *ngIf="!hideStatus"
      [selected]="status"
      [colorObject]="colorsByStatus"
      [textObject]="statusNames"
      [selections]="statusOptions"
      [readOnly]="readOnly"
      (select)="changeStatusTransformer($event)"
    ></traffic-light-dropdown>
    <div style="flex:1" *ngIf="briefStatus"></div>
    <ng-content select=".narrowContentInnerRight"></ng-content>  
    <div style="flex:1" *ngIf="briefStatus"></div>

    <div class="brief-toggle" *ngIf="briefStatus">
      <div class="toggle-text" [ngClass]="{selected: briefStatus === 'Briefed'}">{{ statusNames[briefStatus] || 'Not Briefed' }}</div>
      <mat-slide-toggle *ngIf="!readOnly"
        [ngClass]="{selected: briefStatus === 'Briefed'}"
        [checked]="briefStatus === 'Briefed'"
        (change)="changeBriefStatusTransformer(briefStatus === 'Briefed' ? 'NotBriefed' : 'Briefed')" ></mat-slide-toggle>
    </div>
    <div style="flex:1" *ngIf="readyStatus"></div>
    <traffic-light-dropdown
      *ngIf="readyStatus"
      [selected]="readyStatus"
      [colorObject]="colorsByStatus"
      [textObject]="statusNames"
      [selections]="readyOptions"
      [readOnly]="readOnly"
      (select)="changeReadyStatusTransformer($event)"
    ></traffic-light-dropdown>
    <div style="flex:1" *ngIf="buttonText"></div>
    <inverse-button *ngIf="buttonText" class="right" height="20px" (click)="clickButton.emit()">{{ buttonText }}</inverse-button>
  </ng-container>
</grey-wrapper>
<grey-wrapper *ngIf="wideFormat" class="wide">
  <div class="wide-body">
    <ng-content select=".wideContent"></ng-content>
    <div style="flex:1"></div>
    <ng-container *ngIf="!!middleText">
      <div>{{ middleText }}</div>
      <div style="flex:1"></div>
    </ng-container>
    <img class="logo" *ngIf="logoUrl" class="logo" [src]="logoUrl"> 
    <div style="flex:1" *ngIf="!readOnly && !hideStatus"></div> 
    <ng-content select=".wideContentInnerRight"></ng-content>  
    <traffic-light-dropdown
      *ngIf="!readOnly && !hideStatus"
      [ngClass]="{sponsor: !briefStatus}"
      [selected]="status"
      [colorObject]="colorsByStatus"
      [textObject]="statusNames"
      [selections]="statusOptions"
      [readOnly]="readOnly"
      (select)="changeStatusTransformer($event)"
    ></traffic-light-dropdown>
    <traffic-light-dropdown *ngIf="briefStatus && !readOnly && !hideStatus"
      class="right"
      [selected]="briefStatus === 'NotBriefed' ? 'NotBriefed' : briefStatus"
      [colorObject]="colorsByStatus"
      [textObject]="statusNames"
      [selections]="['Briefed', 'NotBriefed']"
      [readOnly]="readOnly"
      (select)="changeBriefStatusTransformer($event)"
    ></traffic-light-dropdown>
    <traffic-light-dropdown
      *ngIf="readyStatus"
      [selected]="readyStatus"
      [colorObject]="colorsByStatus"
      [textObject]="statusNames"
      [selections]="readyOptions"
      [readOnly]="readOnly"
      (select)="changeReadyStatusTransformer($event)"
    ></traffic-light-dropdown>
    <traffic-light-dropdown
      *ngIf="quoteStatus"
      [selected]="quoteStatus"
      [colorObject]="colorsByStatus"
      [selections]="quoteStatusOptions"
      [readOnly]="readOnly"
      (select)="changeQuoteStatusTransformer($event)"
    ></traffic-light-dropdown>
    <ng-container [ngTemplateOutlet]="dotMenu"></ng-container>
  </div>
  
</grey-wrapper>
<ng-template #dotMenu>
  <div class="dot-menu-holder" *ngIf="threeDotOptions?.length && !readOnly" [matMenuTriggerFor]="dotMenu" (click)="$event.stopPropagation()">
    <icon class="dots" matIcon="more_vert"></icon>
  </div>
  <mat-menu #dotMenu="matMenu" xPosition="before">
    <button mat-menu-item *ngFor="let option of threeDotOptions" 
      (click)="threeDotSelection.emit({ option: option.id, event: $event })" >{{ option.name }}</button>
  </mat-menu>
</ng-template>


`,
    styleUrls: ['status-wrapper.scss'],
    standalone: true,
    imports: [GreyWrapperComponent, MatSlideToggleModule, InverseButtonComponent, MatMenuModule, IconComponent, TrafficLightDropdownComponent, CommonModule, DeleteButtonComponent]
})

export class StatusWrapperComponent {
  @Input() buttonText
  @Input() status = performerStatus.NotInvited as string
  @Input() briefStatus: keyof typeof briefStatus | string | null = null
  @Input() deleteText = ''
  @Input() deleteTitle = ''
  @Input() readOnly = false
  @Input() wideFormat = false
  @Input() threeDotOptions
  @Input() logoUrl
  @Input() hideStatus = false
  @Input() middleText
  @Input() readyStatus: 'Ready' | 'NotReady'
  @Input() icon: string = null

  @Input() quoteStatus: QuoteStatus
  quoteStatusOptions: QuoteStatus[] = ['Accepted', 'Pending', 'Declined']


  statusNames = performerStatusNames // has all of the names you need, including
  colorsByStatus = colorsByStatus
  @Input() statusOptions: StatusType[] = Object.values(performerStatus)

  readyOptions: StatusType[] = ['Ready', 'NotReady']
  briefStatusOptions = Object.values(briefStatus)
  @Output() clickButton: EventEmitter<any> = new EventEmitter()
  @Output() delete: EventEmitter<void> = new EventEmitter()
  @Output() changeStatus: EventEmitter<StatusType> = new EventEmitter()
  @Output() changeBriefStatus: EventEmitter<StatusType> = new EventEmitter()
  @Output() changeQuoteStatus: EventEmitter<QuoteStatus> = new EventEmitter()
  @Output() threeDotSelection: EventEmitter<any> = new EventEmitter()
  @Output() changeReadyStatus: EventEmitter<boolean> = new EventEmitter()

  changeStatusTransformer(status: string) {
    this.changeStatus.emit(status as StatusType)
  }

  changeBriefStatusTransformer(status: string) {
    this.changeBriefStatus.emit(status as StatusType)
  }

  changeQuoteStatusTransformer(status: string) {
    this.changeQuoteStatus.emit(status as QuoteStatus)
  }

  changeReadyStatusTransformer(status: string) {
    this.changeReadyStatus.emit(status === 'Ready' ? true : false)
  }

}


